<template>
	<div class='content'>
		<div class='banner'>
			<!-- <h1>城市大共享计划</h1> -->
			<img :src='src' />
		</div>
		<div class='introduce'>
			<div class='text mar1'>
				<p>开放平台和共享精神</p>
				<p>接纳每一颗热衷共享的种子</p>
				<p>一同繁衍它的“城市大共享计划”</p>
			</div>
			<div class='pic mar1'>
				<img :src='src2' />
				<div class='ad'>
					<h3>联系我们</h3>
					<p class='word'>这里不仅是球技切磋的竞技场，更是休闲放松的雅致空间。</p>
					<p class='word'>我们精心打造了一个集专业与娱乐于一体的台球爱好者的梦幻之地，旨在为每一位踏入这里的您，带来无与伦比的击球体验与心灵享受。</p>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'shareContent',
		data () {
			return {
				src: '/static/img/share1.png',
				src2: '/static/img/concat.png'
			}
		}
	}
</script>
<style lang='scss'>
	@mixin fade-in {
        -webkit-animation: fadeIn 2s 0.5s ease both;
        -moz-animation: fadeIn 2s 0.5s ease both;
        -ms-animation: fadeIn 2s 0.5s ease both;
        -o-animation: fadeIn 2s 0.5s ease both;
        animation: fadeIn 2s 0.5s ease both;		
	}
	.content .banner h1{
		position: absolute;
		width: 100%;
		top: 40%;
		z-index: 8;
		color: white;
		font-size: 66px;
		@include fade-in;
	}
	.introduce {
		position: relative;
		width: 100%;
		height: 100%;
		top: -10%;
		img {
			width: 400px;
			height: 400px;
		}
	}
	.pic{
		position: relative;
		img{
			left: -15%;
			position: relative;
		}
	}	
	.ad{
		position: absolute;
		top: 10%;
		left: 55%;
        width: 336px;
		 h3 {
			text-align: left;
			font-size: 36px;
			color: #585858;
			font-weight: 500;
		}
	}
	.word{
		font-size: 14px;
		color: #4b4b4b;
		line-height: 22px;
		text-align: left;
		margin: 0;
		padding: 0;
        padding-bottom: 10px;
	}
	.mar1{
		margin: 50px 0 50px;
	}
</style>


// WEBPACK FOOTER //
// shareContent.vue?0cce520c